const env = process.env.NODE_ENV || "development";

const domainEnvironment = {
  development: {
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName:"",
  },
  production: {
      domainAdminSide: "https://admin.lamdong.cgis.asia",
      domainUserSide: "https://lamdong.cgis.asia",
      domainName:"lamdong.cgis.asia",
  },
};

module.exports = domainEnvironment[env];
